module.exports = __webpack_public_path__ + "img/addSignuser.6fe89cc1.png";